import getApi from '../../../api/apisauceConfig'

export const deleteTrustedSource = (id: number) =>
getApi().delete<null>(`/trusted_sources/${id}`)

